import React from 'react'
import clsx from 'clsx'
import * as PropTypes from 'prop-types'

import styles from './PaymentMethod.module.scss'

const PaymentMethod = ({
  backgroundColor = null,
  active = false,
  disabled = false,
  children = null,
  title = '',
  icon = null,
}) => {
  return (
    <div
      style={{ backgroundColor }}
      className={clsx([
        styles['payment-method'],
        { [styles['payment-method_disabled']]: disabled },
        { [styles['payment-method_active']]: active },
      ])}
    >
      <div className={styles['payment-method__logo']}>{icon}</div>
      <div className={styles['payment-method__title']}>{title}</div>
      {children}
    </div>
  )
}

PaymentMethod.propTypes = {
  title: PropTypes.string,
  active: PropTypes.bool,
  disabled: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.oneOf([null])]),
  icon: PropTypes.oneOfType([PropTypes.node, PropTypes.oneOf([null])]),
  backgroundColor: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.oneOf([null]),
  ]),
}

export default PaymentMethod
